import List from './list.vue';
import New from './new.vue';
import Edit from './edit.vue';

export default {
  List,
  Edit,
  New,
};
